import { Box, Button, Grid2, Stack, Typography, useTheme } from "@mui/material";
import { useCatalogContext } from "../context/useCatalogContext";
import { FoodsIcon } from "@foodpilot/foods";
import { EngagedActTypo } from "src/components/Actions/Common/EngagedActTypo";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useActionsContext } from "src/context/Actions/useActionsContext";

export const GridView = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { urls } = useActionsContext();
    const { actionsByParents } = useCatalogContext();

    return (
        <Stack padding={theme.spacing(2)}>
            <Grid2 container spacing={2} columns={{ lg: 12, md: 8, xs: 4 }}>
                {actionsByParents.catalogList.map((item) => {
                    const url = urls.catalogGroup(item.parent.id);

                    return (
                        <Grid2
                            key={item.parent.id}
                            size={4}
                            border={`1px solid ${theme.custom.grey[600]}`}
                            borderRadius={theme.spacing(1.5)}
                        >
                            <Stack padding={theme.spacing(3)} gap={theme.spacing(4)}>
                                <Stack gap={theme.spacing(1)}>
                                    <Box
                                        sx={{
                                            marginLeft: "-4px",
                                        }}
                                    >
                                        <FoodsIcon size={7} icon={item.parent.iconName} />
                                    </Box>
                                    <Typography variant="h3">{item.parent.title}</Typography>
                                </Stack>
                                <Stack gap={theme.spacing(2)}>
                                    <EngagedActTypo
                                        engagedActions={item.engagedActions}
                                        totalActions={item.totalActions}
                                    />
                                    <Link to={url}>
                                        <Button
                                            variant="secondary"
                                            endIcon={<FoodsIcon size={2} icon={"arrowRight"} />}
                                            sx={{
                                                // Link seems to override the color that is not properly set in theme
                                                // specifically for this variant
                                                color: theme.custom.grey[2800],
                                                width: "100%",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <Typography variant="cta">
                                                {t("catalog.grid_view.see_action", "See actions")}
                                            </Typography>
                                        </Button>
                                    </Link>
                                </Stack>
                            </Stack>
                        </Grid2>
                    );
                })}
            </Grid2>
        </Stack>
    );
};
